import React, { useCallback, useEffect, useMemo, useState } from 'react';

import './multi-select-table.scss';

import { Table } from '../common/table/Table';

export const MultiSelectTable = ({
  id,
  columns,
  data,
  loading = false,
  error = false,
  value,
  onSelectionChange
}) => {
  const [selectedItems, setSelectedItems] = useState(
    Array.isArray(value) && value.length ? value : []
  );

  useEffect(() => setSelectedItems(value), [value]);

  const sortedData = useMemo(() => {
    const selectedIds = new Set(selectedItems.map((item) => item.id));

    return [...data].sort((a, b) => {
      const aSelected = selectedIds.has(a.id);
      const bSelected = selectedIds.has(b.id);

      if (aSelected === bSelected) return 0;

      return aSelected ? -1 : 1;
    });
  }, [data, selectedItems]);

  const handleSelectionChange = useCallback(
    (row) => {
      let items;

      if (selectedItems.some((item) => item.id === row.id)) {
        items = selectedItems.filter((item) => item.id !== row.id);
      } else {
        items = [...selectedItems, row];
      }
      setSelectedItems(items);
      onSelectionChange(items);
    },
    [onSelectionChange, selectedItems]
  );

  const selectionColumns = useMemo(
    () => [
      {
        id: 'selected',
        accessorKey: 'id',
        title: 'Selected',
        size: 32,
        minSize: 32,
        maxSize: 23,
        header: '',
        filterFn: 'tableFilterFn',
        cell: ({ row }) => (
          <input
            type="checkbox"
            className="multi-select-table__checkbox"
            checked={selectedItems.some((item) => item.id === row.original.id)}
            onClick={(e) => {
              e.stopPropagation();
              handleSelectionChange(row.original);
            }}
            readOnly
          />
        )
      },
      ...columns
    ],
    [columns, selectedItems, handleSelectionChange]
  );

  return (
    <Table
      id={id}
      columns={selectionColumns}
      data={sortedData}
      loading={loading}
      error={error}
      canExport={false}
      showAll
      showHeader={false}
      onRowClick={handleSelectionChange}
    />
  );
};
